export default __webpack_public_path__ + "2c98e85a29c5bdd6eb87b4a9f7a06ae1.svg";